
const SET_FROM_DATE = 'SET_FROM_DATE';
const SET_TO_DATE = 'SET_TO_DATE';
const SET_ACTIVITY_TYPES = 'SET_ACTIVITY_TYPES';
const SET_DIRECTION = 'SET_DIRECTION';
const SET_HUB = 'SET_HUB';
const SET_COLLABORATORS = 'SET_COLLABORATORS';
const SET_SKILLS = 'SET_SKILLS';
const SET_FUNCTIONS = 'SET_FUNCTIONS';
const SET_BILLING_CUSTOMERS = 'SET_BILLING_CUSTOMERS';
const SET_AUDITED_CUSTOMERS = 'SET_AUDITED_CUSTOMERS';
const SET_REFERENTIALS = 'SET_REFERENTIALS';
const SET_REFERENTIAL_TYPES = 'SET_REFERENTIAL_TYPES';
const SET_OF_NUMBER = 'SET_OF_NUMBER';

const REDUCER_ACTIONS = {
  SET_FROM_DATE,
  SET_TO_DATE,
  SET_ACTIVITY_TYPES,
  SET_DIRECTION,
  SET_HUB,
  SET_COLLABORATORS,
  SET_SKILLS,
  SET_FUNCTIONS,
  SET_BILLING_CUSTOMERS,
  SET_AUDITED_CUSTOMERS,
  SET_REFERENTIALS,
  SET_REFERENTIAL_TYPES,
  SET_OF_NUMBER,
}
export default REDUCER_ACTIONS;
